import ComeBackAlive from '../assets/images/come-back-alive.svg';
import VoiceOfChildren from '../assets/images/voice-of-children.svg';
import NovaUkraine from '../assets/images/nova-ukraine.svg';

export const ORGANIZATIONS = [
  {
    name: 'Come Back Alive',
    image: ComeBackAlive,
    link: 'https://www.comebackalive.in.ua/',
  },
  {
    name: 'Voice of Children',
    image: VoiceOfChildren,
    link: 'https://voices.org.ua/en/',
    className: 'h-16',
  },
  {
    name: 'Nova Ukraine',
    image: NovaUkraine,
    link: 'https://novaukraine.org/',
  },
];
